module.exports = __webpack_public_path__ + "static/img/j2.3ddb54a9.jpg";